const transportLabels = {
  walking: 'Te voet',
  bike: 'Fiets',
  'e-bike': 'E-Bike',
  ov: 'Trein, tram of bus',
  bike_ov: 'Fiets + trein/tram/bus',
  car_ov: 'Auto + trein/tram/bus',
  car: 'Auto',
};

export { transportLabels };
